'use client';

import { Link } from './link';
import { NavbarAccountButton, NavbarSystemLink } from './navbar-account-button';
import { ThemeToggle } from './theme-toggle';

interface IMobileNavPanelProps {
  open: boolean;
  links: { href: string; label: string }[];
}

export function MobileNavPanel({ open, links }: IMobileNavPanelProps): React.JSX.Element {
  return (
    <div
      id="mobile-nav-panel"
      hidden={!open}
      className="lg:hidden overflow-hidden rounded-2xl bg-white/10 backdrop-blur-2xl backdrop-saturate-150 border border-white/10 shadow-lg px-4 data-[state=open]:max-h-[600px] data-[state=closed]:max-h-0 transition-[max-height] duration-300 ease-out"
      data-state={open ? 'open' : 'closed'}
    >
      <div className="flex flex-col gap-6 py-4">
        {links.map(({ href, label }) => (
          <Link key={href} href={href} className="text-base font-medium text-foreground">
            {label}
          </Link>
        ))}
        <NavbarSystemLink />
        <NavbarAccountButton />
        <ThemeToggle />
      </div>
    </div>
  );
}
